/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * MVP app scanner service
 */
namespace Application.Services {
    'use strict';
    
    import IJob = Models.IJob;
    import IJobRequest = Models.IJobRequest;

    /**
     * MVPAppScannerJob service
     */
    export class MVPAppScannerJobService {
        public static $name: string = "mvpAppScannerJobService";
        public static $inject: string[] = ['$http'];

        private http: ng.IHttpService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'flexocore/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'mvpadapter/jobs/appscanner';

        constructor($http: ng.IHttpService) {
            this.http = $http;
        }
        
        public createMVPAppScannerJob(portScannerJobRequest: IJobRequest): ng.IPromise<IJob> {
            return this.http.post(this.backendUrl, portScannerJobRequest)
                .then((data: ng.IHttpPromiseCallbackArg<IJob>) => {
                    return this.burnishNode(data.data);
                });
        }
        
        public getJobsByProbeSerial(probeSerial: string): ng.IPromise<IJob[]> {
            return this.http.get(this.backendUrl + "/findbyprobeserial/" + probeSerial)
                .then((data: ng.IHttpPromiseCallbackArg<IJob[]>) => {
                    data.data.forEach((job: IJob) => {
                        this.burnishNode(job);
                    });
                    return data.data;
                });
        }

        public getJobsByProbeId(probeId: number): ng.IPromise<IJob[]> {
            return this.http.get(this.backendUrl + "/findbyprobeid/" + probeId)
                .then((data: ng.IHttpPromiseCallbackArg<IJob[]>) => {
                    data.data.forEach((job: IJob) => {
                        this.burnishNode(job);
                    });
                    return data.data;
                });
        }
        
        public getJobById(jobId: string): ng.IPromise<IJob> {
            return this.http.get(this.backendUrl + "/" + jobId)
                .then((data: ng.IHttpPromiseCallbackArg<IJob>) => {
                    return this.burnishNode(data.data);
                });
        }

        public deleteJobById(jobId: string): ng.IHttpPromise<boolean> {
            return this.http.delete(this.backendUrl + "/" + jobId);
        }

        private burnishNode(element: IJob): IJob {
            element.jobType = Models.JobType.MVP_APP_SCANNER;
            return element;
        }

    }
}